<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">{{ $t('dashboard.main.title') }}</h1>

    <master-form v-if="!isAdmin" :streets="streets"></master-form>
    <span v-else>{{ $t('dashboard.main.hello') }}</span>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import MasterForm from '@/Shared/MasterForm'

export default {
  components: {
    Head,
    MasterForm,
  },
  layout: Layout,
  props: {
    streets: Array,
  },
}
</script>
